module.exports = __webpack_public_path__ + "58567e607d2ae4c2394435a60bffd04a.jpg";